(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["yg-logo-list-01"] && !Shopify.designMode) return;
  try {
    
  class YGLogoList01 extends HTMLElement {
    connectedCallback() {
      this.$scroller = this.querySelector('.yg-logo-list-01-scroller');
      this.$toggle = this.querySelector('[data-logo-list-toggle]');
      this.$label = this.querySelector('[data-logo-list-toggle-label]');
      this.items = Array.from(this.querySelectorAll('[data-logo-list-item]'));
      this.isDragging = false;
      this.hasDragged = false;
      this.dragStartX = 0;
      this.dragStartScrollLeft = 0;

      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handleClick = this.handleClick.bind(this);

      if (this.$scroller) {
        this.$scroller.addEventListener('pointerdown', this.handlePointerDown);
        this.$scroller.addEventListener('pointermove', this.handlePointerMove);
        this.$scroller.addEventListener('pointerup', this.handlePointerUp);
        this.$scroller.addEventListener('pointercancel', this.handlePointerUp);
        this.$scroller.addEventListener('click', this.handleClick, true);
      }

      if (!this.$toggle) {
        return;
      }

      this.mobileItemCount = Number(this.dataset.mobileItemCount) || 4;
      this.handleToggle = this.handleToggle.bind(this);
      this.$toggle.addEventListener('click', this.handleToggle);
      this.setExpanded(false);
    }

    disconnectedCallback() {
      if (this.$scroller) {
        this.$scroller.removeEventListener('pointerdown', this.handlePointerDown);
        this.$scroller.removeEventListener('pointermove', this.handlePointerMove);
        this.$scroller.removeEventListener('pointerup', this.handlePointerUp);
        this.$scroller.removeEventListener('pointercancel', this.handlePointerUp);
        this.$scroller.removeEventListener('click', this.handleClick, true);
      }

      if (this.$toggle && this.handleToggle) {
        this.$toggle.removeEventListener('click', this.handleToggle);
      }
    }

    handlePointerDown(event) {
      if (!this.canDrag()) {
        return;
      }

      this.isDragging = true;
      this.hasDragged = false;
      this.dragStartX = event.clientX;
      this.dragStartScrollLeft = this.$scroller.scrollLeft;
      this.$scroller.classList.add('is-dragging');
      this.$scroller.setPointerCapture(event.pointerId);
    }

    handlePointerMove(event) {
      if (!this.isDragging) {
        return;
      }

      const dragDistance = event.clientX - this.dragStartX;

      if (Math.abs(dragDistance) > 4) {
        this.hasDragged = true;
      }

      this.$scroller.scrollLeft = this.dragStartScrollLeft - dragDistance;
    }

    handlePointerUp(event) {
      if (!this.isDragging) {
        return;
      }

      this.isDragging = false;
      this.$scroller.classList.remove('is-dragging');

      if (this.$scroller.hasPointerCapture(event.pointerId)) {
        this.$scroller.releasePointerCapture(event.pointerId);
      }
    }

    handleClick(event) {
      if (!this.hasDragged) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      this.hasDragged = false;
    }

    canDrag() {
      return window.matchMedia('(min-width: 700px)').matches && this.$scroller.scrollWidth > this.$scroller.clientWidth;
    }

    handleToggle() {
      const isExpanded = this.$toggle.getAttribute('aria-expanded') === 'true';
      this.setExpanded(!isExpanded);
    }

    setExpanded(isExpanded) {
      const moreText = this.$toggle.dataset.moreText || 'Learn More';
      const lessText = this.$toggle.dataset.lessText || 'Learn Less';

      this.$toggle.setAttribute('aria-expanded', String(isExpanded));
      this.$label.textContent = isExpanded ? lessText : moreText;

      this.items.forEach((item, index) => {
        if (index >= this.mobileItemCount) {
          item.dataset.mobileHidden = isExpanded ? 'false' : 'true';
        }
      });
    }
  }

  if (!window.customElements.get('yg-logo-list-01')) {
    window.customElements.define('yg-logo-list-01', YGLogoList01);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-media-group-power"] && !Shopify.designMode) return;
  try {
    
  class YGMediaGroupPower extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.frame = null;
      this.mobileAutoplayQuery = window.matchMedia('(max-width: 699px)');
      this.handleSwiperChange = this.handleSwiperChange.bind(this);
      this.handleMobileAutoplayChange = this.handleMobileAutoplayChange.bind(this);
    }

    connectedCallback() {
      this.addMobileAutoplayListener();
      this.initSwiperProgress();
    }

    disconnectedCallback() {
      if (this.frame) {
        window.cancelAnimationFrame(this.frame);
      }

      if (this.swiper && typeof this.swiper.off === 'function') {
        this.swiper.off('init', this.handleSwiperChange);
        this.swiper.off('slideChange', this.handleSwiperChange);
        this.swiper.off('paginationUpdate', this.handleSwiperChange);
      }

      if (this.mobileAutoplayQuery.removeEventListener) {
        this.mobileAutoplayQuery.removeEventListener('change', this.handleMobileAutoplayChange);
      } else {
        this.mobileAutoplayQuery.removeListener(this.handleMobileAutoplayChange);
      }
    }

    addMobileAutoplayListener() {
      if (this.mobileAutoplayQuery.addEventListener) {
        this.mobileAutoplayQuery.addEventListener('change', this.handleMobileAutoplayChange);
        return;
      }

      this.mobileAutoplayQuery.addListener(this.handleMobileAutoplayChange);
    }

    initSwiperProgress() {
      const $swiper = this.querySelector('yg-swiper');

      if (!$swiper || this.swiper) return;

      this.swiper = $swiper.swiper;

      if (!this.swiper) {
        this.frame = window.requestAnimationFrame(() => this.initSwiperProgress());
        return;
      }

      this.updateBulletProgress(this.swiper);
      this.swiper.on('init', this.handleSwiperChange);
      this.swiper.on('slideChange', this.handleSwiperChange);
      this.swiper.on('paginationUpdate', this.handleSwiperChange);
      this.syncMobileAutoplay(this.swiper);
    }

    handleSwiperChange(swiper) {
      if (!this.mobileAutoplayQuery.matches) {
        this.clearBulletProgress();
        return;
      }

      this.updateBulletProgress(swiper);
    }

    handleMobileAutoplayChange() {
      this.syncMobileAutoplay(this.swiper);
    }

    syncMobileAutoplay(swiper) {
      if (!swiper || !swiper.params?.autoplay || !swiper.autoplay) return;

      if (this.mobileAutoplayQuery.matches) {
        this.enableMobileLoop(swiper);

        if (!swiper.autoplay.running) {
          swiper.autoplay.start();
        }

        this.updateBulletProgress(swiper);
        return;
      }

      this.disableDesktopLoop(swiper);
      swiper.autoplay.stop();
      this.clearBulletProgress();
    }

    enableMobileLoop(swiper) {
      if (!swiper || swiper.params.loop) return;

      swiper.params.loop = true;
      swiper.originalParams.loop = true;

      if (typeof swiper.loopCreate === 'function') {
        swiper.loopCreate();
      }

      swiper.update();
    }

    disableDesktopLoop(swiper) {
      if (!swiper || !swiper.params.loop) return;

      if (typeof swiper.loopDestroy === 'function') {
        swiper.loopDestroy();
      }

      swiper.params.loop = false;
      swiper.originalParams.loop = false;
      swiper.update();
      swiper.slideTo(swiper.realIndex || 0, 0);
    }

    clearBulletProgress() {
      const bullets = this.querySelectorAll('.swiper-pagination-bullet');
      const pagination = this.querySelector('.swiper-pagination');

      if (pagination) {
        pagination.style.removeProperty('--yg-pagination-progress-duration');
        pagination.classList.remove('yg-pagination-progress-ready');
      }

      bullets.forEach((bullet) => {
        bullet.style.removeProperty('--yg-bullet-progress-duration');
        bullet.classList.remove('yg-bullet-progress-ready');
      });
    }

    updateBulletProgress(swiper) {
      const bullets = this.querySelectorAll('.swiper-pagination-bullet');
      const pagination = this.querySelector('.swiper-pagination');

      const currentSlide = swiper.slides[swiper.activeIndex];
      const delay = Number(currentSlide?.dataset.swiperAutoplay || swiper.params.autoplay?.delay || 10000);
      const duration = Math.max(delay, 0) / 1000;

      if (pagination) {
        pagination.style.removeProperty('--yg-pagination-progress-duration');
        pagination.classList.remove('yg-pagination-progress-ready');
      }

      bullets.forEach((bullet) => {
        bullet.style.removeProperty('--yg-bullet-progress-duration');
        bullet.classList.remove('yg-bullet-progress-ready');
      });

      const activeBullet = this.querySelector('.swiper-pagination-bullet-active');

      if (!activeBullet && !pagination?.classList.contains('swiper-pagination-progressbar')) return;

      if (activeBullet) {
        activeBullet.style.setProperty('--yg-bullet-progress-duration', `${duration}s`);
        void activeBullet.offsetWidth;
        activeBullet.classList.add('yg-bullet-progress-ready');
        return;
      }

      pagination.style.setProperty('--yg-pagination-progress-duration', `${duration}s`);
      void pagination.offsetWidth;
      pagination.classList.add('yg-pagination-progress-ready');
    }
  }

  if (!window.customElements.get('yg-media-group-power')) {
    window.customElements.define('yg-media-group-power', YGMediaGroupPower);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column-01"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-tabs-03"] && !Shopify.designMode) return;
  try {
    
    class YGTabs03 extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = 0;
        this.mediaSwiper = null;
        this.contentSwiper = null;
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeydown = this.handleTabKeydown.bind(this);
        this.handleMediaSlideChange = this.handleMediaSlideChange.bind(this);
        this.handleResize = this.handleResize.bind(this);
      }

      get sectionElements() {
        if (this._sectionElements) {
          return this._sectionElements;
        }

        this._sectionElements = {
          tabsTrack: this.querySelector('[data-tabs-track]'),
          tabsScrollContainer: this.querySelector('[data-tabs-scroll]'),
          tabs: Array.from(this.querySelectorAll('.yg-tabs-03__tab')),
          mediaSwiper: this.querySelector('[data-media-swiper]'),
          contentSwiper: this.querySelector('[data-content-swiper]'),
          contentSlides: Array.from(this.querySelectorAll('.yg-tabs-03__content-slide')),
        };

        return this._sectionElements;
      }

      connectedCallback() {
        if (this.initialized) {
          return;
        }

        this.initialized = true;

        this.sectionElements.tabs.forEach((tab) => {
          tab.addEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.addEventListener('keydown', this.handleTabKeydown);
        window.addEventListener('resize', this.handleResize);

        this.mountSwipers();
      }

      disconnectedCallback() {
        this.sectionElements.tabs.forEach((tab) => {
          tab.removeEventListener('click', this.handleTabClick);
        });

        this.sectionElements.tabsTrack?.removeEventListener('keydown', this.handleTabKeydown);
        window.removeEventListener('resize', this.handleResize);

        if (this.mediaSwiper) {
          this.mediaSwiper.off('slideChange', this.handleMediaSlideChange);
          this.mediaSwiper = null;
        }

        if (this.contentSwiper) {
          this.contentSwiper = null;
        }

        this.initialized = false;
      }

      mountSwipers(attempt = 0) {
        const mediaSwiperElement = this.sectionElements.mediaSwiper;
        const contentSwiperElement = this.sectionElements.contentSwiper;

        if (!mediaSwiperElement || !contentSwiperElement) {
          return;
        }

        if (!mediaSwiperElement.swiper || !contentSwiperElement.swiper) {
          if (attempt < 10) {
            window.setTimeout(() => this.mountSwipers(attempt + 1), 150);
          }
          return;
        }

        if (!this.mediaSwiper) {
          this.mediaSwiper = mediaSwiperElement.swiper;
          this.mediaSwiper.on('slideChange', this.handleMediaSlideChange);
        }

        if (!this.contentSwiper) {
          this.contentSwiper = contentSwiperElement.swiper;
        }

        this.mediaSwiper.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.mediaSwiper.params.allowTouchMove = this.sectionElements.tabs.length > 1;
        this.contentSwiper.allowTouchMove = false;
        this.contentSwiper.params.allowTouchMove = false;
        this.contentSwiper.params.autoHeight = true;

        this.setActiveState(0, {
          syncSwiper: false,
          scrollBehavior: 'auto',
        });
      }

      handleTabClick(event) {
        const tab = event.currentTarget;
        const index = Number(tab.dataset.tabIndex);

        this.setActiveState(index);
      }

      handleTabKeydown(event) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          return;
        }

        const currentIndex = this.activeIndex;
        const lastIndex = this.sectionElements.tabs.length - 1;
        let nextIndex = currentIndex;

        if (event.key == 'ArrowLeft') {
          nextIndex = currentIndex > 0 ? currentIndex - 1 : lastIndex;
        } else if (event.key == 'ArrowRight') {
          nextIndex = currentIndex < lastIndex ? currentIndex + 1 : 0;
        } else if (event.key == 'Home') {
          nextIndex = 0;
        } else if (event.key == 'End') {
          nextIndex = lastIndex;
        }

        event.preventDefault();

        const nextTab = this.sectionElements.tabs[nextIndex];
        if (nextTab) {
          nextTab.focus();
        }

        this.setActiveState(nextIndex);
      }

      handleMediaSlideChange() {
        const nextIndex = typeof this.mediaSwiper.realIndex === 'number'
          ? this.mediaSwiper.realIndex
          : this.mediaSwiper.activeIndex;

        if (this.contentSwiper && this.contentSwiper.activeIndex !== nextIndex) {
          this.contentSwiper.slideTo(nextIndex);
        }

        this.setActiveState(nextIndex, {
          syncSwiper: false,
        });
      }

      handleResize() {
        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView('auto');
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }

      isTabsOverflowing() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return false;
        }

        return scrollContainer.scrollWidth > scrollContainer.clientWidth + 1;
      }

      scrollActiveTabIntoView(behavior = 'smooth') {
        const scrollContainer = this.sectionElements.tabsScrollContainer;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!activeTab || !scrollContainer) {
          return;
        }

        if (this.isTabsOverflowing()) {
          const containerRect = scrollContainer.getBoundingClientRect();
          const itemRect = activeTab.getBoundingClientRect();
          const currentScrollLeft = scrollContainer.scrollLeft;
          const rawScrollLeft = currentScrollLeft + (itemRect.left - containerRect.left) - ((scrollContainer.clientWidth - itemRect.width) / 2);
          const maxScrollLeft = Math.max(scrollContainer.scrollWidth - scrollContainer.clientWidth, 0);
          const nextScrollLeft = Math.min(Math.max(rawScrollLeft, 0), maxScrollLeft);

          if (typeof scrollContainer.scrollTo === 'function') {
            scrollContainer.scrollTo({
              left: nextScrollLeft,
              behavior: behavior,
            });
          } else {
            scrollContainer.scrollLeft = nextScrollLeft;
          }
        }
      }

      updateOverflowState() {
        const scrollContainer = this.sectionElements.tabsScrollContainer;

        if (!scrollContainer) {
          return;
        }

        scrollContainer.classList.toggle('is-overflowing', this.isTabsOverflowing());
      }

      updateIndicator() {
        const tabsTrack = this.sectionElements.tabsTrack;
        const activeTab = this.sectionElements.tabs[this.activeIndex];

        if (!tabsTrack || !activeTab) {
          return;
        }

        tabsTrack.style.setProperty('--tabs-03-indicator-left', `${activeTab.offsetLeft}px`);
        tabsTrack.style.setProperty('--tabs-03-indicator-width', `${activeTab.offsetWidth}px`);
      }

      pauseAllVideos() {
        this.querySelectorAll('.yg-tabs-03__media-slide yg-video').forEach((videoElement) => {
          if (typeof videoElement.pauseVideo === 'function') {
            videoElement.pauseVideo();
          }
        });
      }

      playActiveVideo() {
        this.pauseAllVideos();

        const activeSlide = this.querySelector(`.yg-tabs-03__media-slide[data-slide-index="${this.activeIndex}"]`);
        const activeVideo = activeSlide?.querySelector('yg-video');

        if (activeVideo && typeof activeVideo.playVideo === 'function') {
          activeVideo.playVideo();
        }
      }

      setActiveState(index, options = {}) {
        const safeIndex = Math.max(0, Math.min(index, this.sectionElements.tabs.length - 1));
        const syncSwiper = options.syncSwiper !== false;
        const scrollBehavior = options.scrollBehavior || 'smooth';

        this.activeIndex = safeIndex;

        if (syncSwiper) {
          if (this.mediaSwiper && this.mediaSwiper.activeIndex !== safeIndex) {
            this.mediaSwiper.slideTo(safeIndex);
          }

          if (this.contentSwiper && this.contentSwiper.activeIndex !== safeIndex) {
            this.contentSwiper.slideTo(safeIndex);
          }
        }

        this.sectionElements.tabs.forEach((tab, tabIndex) => {
          const isActive = tabIndex === safeIndex;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        this.sectionElements.contentSlides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === safeIndex ? 'false' : 'true');
        });

        this.updateOverflowState();
        this.updateIndicator();

        if (this.isTabsOverflowing()) {
          this.scrollActiveTabIntoView(scrollBehavior);
        } else if (this.sectionElements.tabsScrollContainer) {
          this.sectionElements.tabsScrollContainer.scrollLeft = 0;
        }

        this.playActiveVideo();

        if (this.contentSwiper) {
          this.contentSwiper.updateAutoHeight(0);
        }
      }
    }

    if (!window.customElements.get('yg-tabs-03')) {
      window.customElements.define('yg-tabs-03', YGTabs03);
    }
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-video-list-02"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", ()=>{
    class YGVideoList02 extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        this.initSwiperProgress();
      }

      initSwiperProgress() {
        const $swiper = this.querySelector('yg-swiper');

        if (!$swiper) return;
        if (this.swiper) return;

        this.swiper = $swiper.swiper;

        if (!this.swiper) {
          window.requestAnimationFrame(() => this.initSwiperProgress());
          return;
        }

        this.handleSwiperChange(this.swiper);

        this.swiper.on('init', (swiper) => {
          this.handleSwiperChange(swiper);
        });

        this.swiper.on('slideChange', (swiper) => {
          this.handleSwiperChange(swiper);
        });

        this.swiper.on('slideChangeTransitionEnd', (swiper) => {
          this.switchVideoStatus(swiper);
        });
      }

      handleSwiperChange(swiper) {
        this.updateBulletProgress(swiper);
      }

      updateBulletProgress(swiper) {
        const currentSlide = swiper.slides[swiper.activeIndex];
        const delay = Number(currentSlide?.dataset.swiperAutoplay || swiper.params.autoplay?.delay || 10000);
        const duration = Math.max(delay, 0) / 1000;
        const bullets = this.querySelectorAll('.swiper-pagination-bullet');

        bullets.forEach((bullet) => {
          bullet.style.removeProperty('--yg-bullet-progress-duration');
          bullet.classList.remove('yg-bullet-progress-ready');
        });

        const activeBullet = this.querySelector('.swiper-pagination-bullet-active');

        if (!activeBullet) return;

        activeBullet.style.setProperty('--yg-bullet-progress-duration', `${duration}s`);
        void activeBullet.offsetWidth;
        activeBullet.classList.add('yg-bullet-progress-ready');
      }

      switchVideoStatus(swiper) {
        const currentSlide = swiper.slides[swiper.activeIndex];

        swiper.slides.forEach((slide) => {
          const video = slide.querySelector('yg-video');

          if (video && typeof video.pauseVideo === 'function') {
            video.pauseVideo();
          }
        });

        const video = currentSlide?.querySelector('yg-video');

        if (video && typeof video.playVideo === 'function') {
          video.playVideo();
        }
      }
    }

    if (!window.customElements.get('yg-video-list-02')) {
      window.customElements.define('yg-video-list-02', YGVideoList02);
    }
  })

  } catch(e) { console.error(e); }
})();
})();
